import { PieChart } from 'echarts/charts';

import { ECHARTS_COLORS } from '../../constants/echarts-colors.constants';
import { EchartsCore } from "../Echart/UseEcharts";

const DoughnutChart = (props) => {
  const { items } = props;

  const ReactEchart = EchartsCore([PieChart]);

  const data = items?.map((item) => ({
    value: item.percent,
    name: item.label,
  })) ?? [];

  const options = {
    color: ECHARTS_COLORS,
    tooltip: {
      trigger: 'item',
      borderWidth: 0,
      formatter: function (params) {
        return `${params.marker} ${params.name}: &nbsp;&nbsp;&nbsp; <b>${params.value}%</b>`;
      },
    },
    series: [
      {
        type: 'pie',
        radius: ['50%', '90%'],
        avoidLabelOverlap: false,
        animationDelay: Math.random() * 500,
        label: {
          show: false,
        },
        labelLine: {
          show: false
        },
        data,
      }
    ]
  };

  return (
    <div style={{ maxWidth: "200px", width: '100%' }}>
      {data.length !== 0 &&
        <ReactEchart
          lazyUpdate
          opt={{ renderer: 'svg' }}
          option={options}
          style={{ height: "200px", width: "100%" }}
        />
      }
    </div>
  )
}

export default DoughnutChart;